export { default } from './QuestionFeedback';